import { render, staticRenderFns } from "./RejectModal.vue?vue&type=template&id=015145fb&"
import script from "./RejectModal.vue?vue&type=script&lang=ts&"
export * from "./RejectModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('015145fb')) {
      api.createRecord('015145fb', component.options)
    } else {
      api.reload('015145fb', component.options)
    }
    module.hot.accept("./RejectModal.vue?vue&type=template&id=015145fb&", function () {
      api.rerender('015145fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TruckingSettlement/RejectModal.vue"
export default component.exports